module.exports = __webpack_public_path__ + "static/img/lunbo3.89a7de56.webp";